import * as actionTypes from "./actionTypes";

export const showLoadingComponent = (activate: boolean) => {
  return {
    type: actionTypes.SHOW_LOADING_COMPONENT,
    activate,
  };
};

export const showErrorInterceptor = (errorCode: string) => {
  return {
    type: actionTypes.SHOW_ERROR_TEXT_INTERCEPTOR,
    errorCode,
  };
};
